<template>
  <a-drawer width="40%" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left"><b>{{ formTitle }}</b></a-divider>
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="时效(月)" prop="durationMonths">
        <a-input-number v-model="form.durationMonths" :min="1" style="width: 200px" />
      </a-form-model-item>
      <a-form-model-item label="价格" prop="price">
        <a-input-number v-model="form.price" :min="0" :precision="2" style="width: 200px" />
      </a-form-model-item>
<!--      <a-form-model-item label="是否永久" prop="isPermanent">-->
<!--        <a-switch :checked="form.isPermanent" @change="(checked) => form.isPermanent = checked" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="排序" prop="sort">
        <a-input-number v-model="form.sort" :min="0" :max="9999" style="width: 200px" />
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status">
        <a-radio-group v-model="form.status">
          <a-radio :value="1">启用</a-radio>
          <a-radio :value="0">禁用</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { addDurationPrice, updateDurationPrice } from '@/api/cloudplant/durationPrice'

export default {
  name: 'CreateForm',
  data() {
    return {
      labelCol: { span: 6 }, wrapperCol: { span: 16 }, submitLoading: false, formTitle: '', open: false, formType: 1,
      form: { id: null, durationMonths: 1, price: 0, isPermanent: false, sort: 0, status: 1 },
      rules: {
        durationMonths: [{ required: true, message: '时效不能为空', trigger: 'blur' }],
        price: [{ required: true, message: '价格不能为空', trigger: 'blur' }]
      }
    }
  },
  methods: {
    onClose() { this.open = false; this.reset() },
    cancel() { this.open = false; this.reset() },
    reset() { this.formType = 1; this.form = { id: null, durationMonths: 1, price: 0, isPermanent: false, sort: 0, status: 1 } },
    handleAdd() { this.reset(); this.formType = 1; this.open = true; this.formTitle = '添加' },
    handleUpdate(row) { this.reset(); this.formType = 2; this.form = { ...row }; this.open = true; this.formTitle = '修改' },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id) {
            updateDurationPrice(this.form).then(() => { this.$message.success('修改成功'); this.open = false; this.$emit('ok') }).finally(() => { this.submitLoading = false })
          } else {
            addDurationPrice(this.form).then(() => { this.$message.success('新增成功'); this.open = false; this.$emit('ok') }).finally(() => { this.submitLoading = false })
          }
        }
      })
    }
  }
}
</script>
